import React from "react";
import { useSelector } from "react-redux";

import { Language } from "../../../utils";
import { Alert, AlertTitle } from "@material-ui/lab";
import { ReactComponent as PaceLineIcon } from "../../../static/images/icons/pace-line.svg";
import makeClasses from "../styles";
import clsx from "clsx";

const StepEleven = ({ history, nextStep, prevStep, stepOneData }) => {
  const classes = makeClasses();

  const { languageTexts } = useSelector((state) => ({
    languageTexts: state.language.texts || {},
  }));

  const i18n = Language(languageTexts);

  return (
    <React.Fragment>
      <div className={classes.formContent}>
        <div className={classes.formTitleContainer}>
          <div className={classes.formTitle}>
            {i18n.get("LegalEntityRegistration.StepFormTitle")}
          </div>
          <div className={classes.formText}>
            {i18n.get("LegalEntityRegistration.Step9FormText")}
          </div>
        </div>
        <Alert
          severity="warning"
          icon={false}
          className={clsx(
            classes.alert,
            classes.alertWarning,
            classes.alertWithNoMarginBottom,
          )}>
          <PaceLineIcon
            className={clsx(classes.alertIcon)}
            width={40}
            height={40}
          />
          <div className={classes.alertMessage}>
            <AlertTitle className={classes.alertTitle}>
              {i18n.get("LegalEntityRegistration.RegisterConfirmationTitle")}
            </AlertTitle>
            <div>
              {i18n.get("LegalEntityRegistration.RegisterConfirmationMessage")}
            </div>
          </div>
        </Alert>
        <div className={classes.textContainer}>
          <div className={classes.primaryText}>
            {i18n.get("LegalEntityRegistration.DownloadAppTitle")}
          </div>
          <div className={classes.secondaryText}>
            {i18n.get("LegalEntityRegistration.DownloadAppText")}
          </div>
          <div className={classes.appDownloadContainer}>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://apps.apple.com/us/app/handy-uy/id6504303787">
              <img src="/download-app-store.png" alt="App Store Badge" />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://play.google.com/store/apps/details?id=uy.handy.app_handy_main_app">
              <img
                src="/download-play-store.png"
                alt="Google Play Store Badge"
              />
            </a>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

StepEleven.id = "com.Handy.LegalEntityRegistration.StepEleven";
export default StepEleven;
